// Teléfono 1 y Teléfono 2 no pueden ser el mismo número (Esteban, 2026-09-27: había 966 alumnos así).
// Se compara el número local: WAPP guarda la clave de país (504 / 52) desde 2026-09-11 y los viejos no.

export function telefonoLocal(telefono: any): string
{
	const d = String(telefono || "").replace(/\D/g, "")
	if(d.length === 11 && d.startsWith("504")) return d.slice(3)
	if(d.length === 12 && d.startsWith("52")) return d.slice(2)
	if(d.length === 13 && d.startsWith("521")) return d.slice(3)
	return d
}

export function mismoTelefono(a: any, b: any): boolean
{
	const x = telefonoLocal(a)
	const y = telefonoLocal(b)
	return x !== "" && y !== "" && x === y
}

// Con +504 van 8 dígitos y con +52 van 10: "52 8134 8562" salió así en un contrato (2026-09-27).
export function telefonoIncompleto(telefono: any): string | null
{
	const d = String(telefono || "").replace(/\D/g, "")
	//Mientras escribe (o solo con la clave puesta) no se regaña: se revisa ya con 6 dígitos o más.
	if(d.startsWith("504") && d.length >= 9 && d.length !== 11) return "Un número de Honduras lleva 8 dígitos después del +504."
	if(d.startsWith("52") && d.length >= 8 && d.length !== 12 && !(d.length === 13 && d.startsWith("521"))) return "Un número de México lleva 10 dígitos después del +52."
	if(d.startsWith("1") && d.length >= 7 && d.length !== 11) return "Un número de Estados Unidos lleva 10 dígitos después del +1."
	return null
}
